import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

export const BookingForm = ({ pid , propertyID}) => {
    const navigate = useNavigate();
    const [guestSelection, setGuestSelection] = useState({});
    const { preBookingDetails, roomDetails, checkInDate, checkOutDate, loading } = useSelector(
        (state) => state.preBooking
    );

    const availableRooms = roomDetails.filter(
        (room) => room.IsAvailable === 1
    );

    const preBookingToken =
        preBookingDetails?.[0]?.PreBookingToken || "";

    const getMealPlans = (mealPlanList) => {
        try {
            return mealPlanList ? JSON.parse(mealPlanList) : [];
        } catch (error) {
            console.log("MealPlan Parse Error:", error);
            return [];
        }
    };

    const handleGuestChange = (roomCode, field, value) => {
        setGuestSelection((prev) => ({
            ...prev,
            [roomCode]: {
                room: prev[roomCode]?.room || 1,
                adults: prev[roomCode]?.adults || 1,
                child: prev[roomCode]?.child || 0,
                [field]: Number(value),
            },
        }));
    };


    const handleBookNow = (room, plan) => {
        const selectionKey = `${room.RoomCode}_${plan.Code}`;

        const roomData = [{
            roomID: room.RoomID,
            roomCode: room.RoomCode,
            roomName: room.RoomName,
            mealPlanCode: plan.Code,
            mealPlanID: plan.MealPlanID,
            mealPlanName: plan.Description,
            roomCount: guestSelection[selectionKey]?.room || 1,
            adults: guestSelection[selectionKey]?.adults || 1,
            child: guestSelection[selectionKey]?.child || 0,
            rate: plan.RoomRate,
        }];

        navigate("/Booking", {
            state: {
                pid,
                PropertyID: propertyID,
                checkInDate,
                checkOutDate,
                rooms: roomData,
                preBookingToken,
            },
        });
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
                </div>
            )}
            {availableRooms?.length > 0 ? (
                availableRooms.map((room, index) => {
                    const mealPlans = getMealPlans(room.MealPlanList);

                    return (
                        <div key={index} className="container d-flex justify-content-center align-items-center"
                        >
                            <div
                                className="card d-flex flex-column flex-md-row"
                                style={{ width: "100%" }}
                            >
                                {/* BEGIN: LeftSection_Image */}
                                <section className="bp-left-section" data-purpose="room-image-container">
                                    <div className="position-relative h-100 w-100 overflow-hidden rounded">
                                        <img
                                            alt={room.RoomName}
                                            className="w-100 h-100 object-fit-cover"
                                            src="https://lh3.googleusercontent.com/aida-public/AB6AXuD8UMPNyok51PR_wbqrY9nZ3iedYyL2LDIhk7DKIHfpbubTcsfwQzr2PULjLX1qZkkzy8ltxOH5BFzogsQCbUmxTen7_hoh_Tx0uc1B3v4u2mn5hqmEp-HJyPCEdBB3FQO6D7Eio3pUjYeQKu_C8R6el64uZX6R65qIKIVCm9mGg_3-hm1Dn4KVz2E-oGMkWR0_Hid77N6BDBYnCYvs4NSY4f-DC0gNqmem1EeGi2UVofGHicXHnbTPKbcpbnATz3U-Wp23s6RLS8s"
                                            style={{ minHeight: 160, maxHeight: 240 }}
                                        />
                                        <div className="bp-room-label" data-purpose="room-type-badge">
                                            Junior Suite
                                        </div>
                                    </div>
                                </section>
                                {/* END: LeftSection_Image */}
                                {/* BEGIN: RightSection_Content */}
                                <section className="bp-right-section" data-purpose="room-details-content">
                                    {/* Header Info */}
                                    <div
                                        className="d-flex justify-content-between align-items-start border-bottom pb-2 mb-3"
                                        data-purpose="room-header"
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            <h2 className="bp-text-blue-primary fs-5 fw-medium mb-0">
                                                {room.RoomName}
                                            </h2>
                                            {/* <a
                                    className="bp-text-green-action text-decoration-none fw-semibold d-flex align-items-center"
                                    href="#"
                                    onclick="event.preventDefault();openMoreInfo()"
                                    style={{ fontSize: 12 }}
                                >
                                    More Info
                                    <svg
                                        className="ms-1"
                                        fill="none"
                                        height={12}
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        width={12}
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={3}
                                        />
                                    </svg>
                                </a> */}
                                        </div>
                                        {/* <div className="d-flex align-items-center gap-2">
                                <div className="bp-info-badge">
                                    <span>3</span>
                                    <svg
                                        className="ms-1"
                                        fill="currentColor"
                                        height={16}
                                        viewBox="0 0 20 20"
                                        width={16}
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            clipRule="evenodd"
                                            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                </div>
                                <div className="bp-info-badge">634.96 sq ft</div>
                                <div className="bp-info-badge">
                                    <svg
                                        fill="none"
                                        height={16}
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        width={16}
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                        />
                                    </svg>
                                </div>
                            </div> */}
                                    </div>
                                    {/* Pricing Row 1 */}
                                    {mealPlans.length > 0 ? (
                                        mealPlans.map((plan, idx) => {
                                            const selectionKey = `${room.RoomCode}_${plan.Code}`;

                                            const totalGuests =
                                                (guestSelection[selectionKey]?.adults || 1) +
                                                (guestSelection[selectionKey]?.child || 0);
                                            return (
                                                <div
                                                    key={idx}
                                                    className={`${idx > 0 ? "border-top pt-4 mt-4" : ""}`}
                                                >
                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                        <div className="d-flex flex-column gap-2">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <h3 className="text-dark fs-6 fw-medium mb-0">
                                                                    {plan.Description}
                                                                </h3>

                                                            </div>
                                                            {/* <div className="bp-info-badge align-self-start bg-white shadow-sm px-2 py-1">
                                                <svg
                                                    className="me-2"
                                                    fill="none"
                                                    height={16}
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    width={16}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M3 5h18M3 10h18M3 15h18M3 20h18"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                    />
                                                </svg>
                                                <span style={{ fontSize: 13 }}>
                                                    Bed &amp; Breakfast
                                                </span>
                                            </div> */}
                                                        </div>
                                                        <div className="d-flex align-items-center gap-4 pe-2">
                                                            <div className="d-flex align-items-center text-dark">
                                                                <span className="fw-bold me-1">{totalGuests}</span>
                                                                <svg
                                                                    fill="currentColor"
                                                                    height={18}
                                                                    viewBox="0 0 20 20"
                                                                    width={18}
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        clipRule="evenodd"
                                                                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                                                        fillRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <div className="bp-room-select-wrapper">
                                                                <span className="bp-room-select-label">Room</span>
                                                                <select
                                                                    className="bp-custom-select"
                                                                    value={guestSelection[selectionKey]?.room || 1}
                                                                    onChange={(e) =>
                                                                        handleGuestChange(selectionKey, "room", e.target.value)
                                                                    }
                                                                >
                                                                    {[...Array(10)].map((_, i) => (
                                                                        <option key={i + 1} value={i + 1}>
                                                                            {i + 1}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="bp-room-select-wrapper">
                                                                <span className="bp-room-select-label">Adults</span>
                                                                <select
                                                                    className="bp-custom-select"
                                                                    value={guestSelection[selectionKey]?.adults || 1}
                                                                    onChange={(e) =>
                                                                        handleGuestChange(selectionKey, "adults", e.target.value)
                                                                    }
                                                                >
                                                                    {[...Array(10)].map((_, i) => (
                                                                        <option key={i + 1} value={i + 1}>
                                                                            {i + 1}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="bp-room-select-wrapper">
                                                                <span className="bp-room-select-label">child</span>
                                                                <select
                                                                    className="bp-custom-select"
                                                                    value={guestSelection[selectionKey]?.child || 0}
                                                                    onChange={(e) =>
                                                                        handleGuestChange(selectionKey, "child", e.target.value)
                                                                    }
                                                                >
                                                                    {[...Array(11)].map((_, i) => (
                                                                        <option key={i} value={i}>
                                                                            {i}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="text-end">
                                                                {/* <div className="bp-price-strikethrough">INR 11,999</div> */}
                                                                <div className="d-flex align-items-center justify-content-end bp-price-main">
                                                                    INR {Number(plan.RoomRate).toLocaleString("en-IN")}
                                                                    <svg
                                                                        className="ms-1 text-secondary"
                                                                        fill="none"
                                                                        height={14}
                                                                        stroke="currentColor"
                                                                        viewBox="0 0 24 24"
                                                                        width={14}
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M9 5l7 7-7 7"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            strokeWidth={2}
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <div className="bp-rate-label">Rate for 1 Night</div>
                                                                <div className="bp-tax-label">Tax Exclusive</div>
                                                            </div>
                                                            <button
                                                                className="btn bp-btn-book"
                                                                onClick={() => handleBookNow(room, plan)}
                                                            >
                                                                Book
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Discount Banner */}
                                                    {/* <div className="bp-discount-container" data-purpose="discount-indicator">
                                        <div className="bp-discount-banner-head">Early Bird Discount</div>
                                        <div className="bp-discount-banner-tail">Save INR 2,500</div>
                                    </div> */}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="text-center text-muted py-3">
                                            No Meal Plans Available
                                        </div>
                                    )}
                                </section>
                                {/* END: RightSection_Content */}
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="container py-5">
                    <div
                        className="card border-0 shadow-sm text-center mx-auto"
                        style={{ maxWidth: "500px" }}
                    >
                        <div className="card-body py-5">
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/6195/6195678.png"
                                alt="No Rooms Available"
                                style={{
                                    width: "120px",
                                    height: "120px",
                                    objectFit: "contain",
                                }}
                            />

                            <h3 className="mt-4 fw-bold text-dark">
                                No Rooms Available
                            </h3>

                            <p className="text-muted mb-4">
                                Sorry! No rooms are available for the selected dates.
                                Please try changing your check-in/check-out dates or
                                modify the guest count.
                            </p>

                            <button
                                className="btn btn-primary px-4"
                                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                            >
                                Modify Search
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
